// Modification provided by Searchanise team. With any questions, contact us at feedback@searchanise.io

/*
This code translates values of the filters based on metafieds.
In the settings section, there is a filterTranslation object that contains all translation data. 

Between the filterTranslation object curly braces, you should place the name of the filter in the target language. For example:

"TEST FILTER": {},

You can add more filters following the same pattern:

"TEST FILTER 1": {},
"TEST FILTER 2": {},

Filter title you use should match the one from your admin panel. The text is case-sensitive.

Between the filter curly braces, you can place the pair of the original filter value text and translated text. For example: 

"TEST FILTER": {
    "original text": "translated text",
}

Each pair should be placed on the new line, each line should end with a comma.
The filter values are case-insensitive.
*/

// SETTINGS START

let filterTranslation = {
"Koncový doraz|Punkt końcowy|Vége|Endpunkt|End point|Koncový doraz|Finecorsa|Point final": {
	"Potrebný doraz pre zatvorenú polohu": {
		"pl": "Wymagany stop dla pozycji zamkniętej",
		"hu": "Szükséges leállítás zárt helyzetben",
		"de": "Erforderlicher Stopp für geschlossene Position",
		"en": "Need end point for close position",
		"cs": "Potřebný doraz pro zavřenou polohu",
		"it": "Finecorsa richiesto per posizione chiusa",
		"fr": "Butée nécessaire pour la position fermée"
	},
	"Potrebný doraz pre otvorenú polohu": {
		"pl": "Wymagany stop dla otwartej pozycji",
		"hu": "A nyitott pozícióhoz szükséges megálló",
		"de": "Erforderlicher Stopp für die offene Position",
		"en": "Need end point for open position",
		"cs": "Potřebný doraz pro otevřenou polohu",
		"it": "Finecorsa richiesto per posizione aperta",
		"fr": "Butée nécessaire pour la position ouverte"
	},
	"Koncové dorazy nie sú potrebné": {
		"pl": "Ograniczniki krańcowe nie są wymagane",
		"hu": "A véglezárások nem szükségesek",
		"de": "Endanschläge sind nicht erforderlich",
		"en": "No need end points",
		"cs": "Koncové dorazy nejsou potřeba",
		"it": "I fine corsa non sono richiesti",
		"fr": "Les butées de fin de course ne sont pas nécessaires"
	},
	"Potrebné dorazy pre otvorenú aj zatvorenú polohu": {
		"pl": "Wymagane przystanki dla pozycji otwartych i zamkniętych",
		"hu": "Szükséges megállók nyitott és zárt pozíciókhoz",
		"de": "Erforderliche Stopps für offene und geschlossene Positionen",
		"en": "Need end points for open and close position",
		"cs": "Potřebné dorazy pro otevřenou i zavřenou polohu",
		"it": "Finecorsa richiesti per entrambe le posizioni aperta e chiusa",
		"fr": "Butées nécessaires pour la position ouverte et fermée"
	},
	"Magneticky koncový doraz": {
		"pl": "Magnetyczny ogranicznik",
		"hu": "Mágneses végütköző",
		"de": "Magnetischer Endanschlag",
		"en": "Magnetic end stop",
		"cs": "Magnetický koncový doraz",
		"it": "Finecorsa magnetico",
		"fr": "Butée magnétique"
	}
 },

"Kotvenie|Mocowanie|Rögzítő elem|Verankerung|Anchoring|Kotvení|Ancoraggio|Ancrage": {
	"Na sklo": {
		"pl": "Od szkła",
		"hu": "üveg",
		"de": "Glas",
		"en": "Glass",
		"cs": "Na sklo",
		"it": "Su vetro",
		"fr": "Sur verre"
	},
	"Na stenu": {
		"pl": "Od ściany",
		"hu": "Fal",
		"de": "Wand",
		"en": "Wall",
		"cs": "Na stěnu",
		"it": "Su parete",
		"fr": "Sur le mur"
	},
	"Z boku": {
		"pl": "Z boku",
		"hu": "az oldalsó",
		"de": "Seitliche",
		"en": "Side",
		"cs": "Z boku",
		"it": "Da lato",
		"fr": "Par le côté"
	},
	"Zhora": {
		"pl": "Z wierzchu",
		"hu": "fentről",
		"de": "Top",
		"en": "Top",
		"cs": "Seshora",
		"it": "Di costassú",
		"fr": "Par le dessus"
	},
	"stena/sklo": {
		"pl": "Ściana/szkło",
		"hu": "fal/üveg",
		"de": "Wand/Glas",
		"en": "wall/glass",
		"cs": "stěna/sklo",
		"it": "parete/vetro",
		"fr": "mur/verre"
	},
	"sklo/sklo": {
		"pl": "szklo/szklo",
		"hu": "üveg/üveg",
		"de": "Glas/Glas",
		"en": "glass/glass",
		"cs": "sklo/sklo",
		"it": "vetro/vetro",
		"fr": "verre/verre"
	}
 },

"Madlo|Poręcz|Kapaszkodó|Handlauf|Handrail|Madlo|Corrimano|Balustrade": {
	"40x40 - plný": {
		"pl": "40x40 - pełny",
		"hu": "40x40 - tömör",
		"de": "40x40 - gefüllt",
		"en": "40x40 - filled",
		"cs": "40x40 - plný",
		"it": "40x40 - pieno",
		"fr": "40x40 - plein"
	},
	"D42 - plné": {
		"pl": "D42 - pełny",
		"hu": "D42 - tömör",
		"de": "D42 - gefüllt",
		"en": "D42 - filled",
		"cs": "D42 - plný",
		"it": "D42 - pieni",
		"fr": "D42 - plein"
	},
	"D45 - plné": {
		"pl": "D45 - pełny",
		"hu": "D45 - tömör",
		"de": "D45 - gefüllt",
		"en": "D45 - filled",
		"cs": "D45 - plný",
		"it": "D45 - pieni",
		"fr": "D45 - plein"
	},
	"D50 - plný": {
		"pl": "D50 - pełny",
		"hu": "D50 - tömör",
		"de": "D50 - gefüllt",
		"en": "D50 - filled",
		"cs": "D50 - plný",
		"it": "D50 - pieni",
		"fr": "D50 - plein"
	},
	"Na navarenie": {
		"pl": "Na spawanie",
		"hu": "Hegesztés",
		"de": "Schweißen",
		"en": "For welding",
		"cs": "Na navaření",
		"it": "Per saldatura",
		"fr": "A souder"
	},
	"Zo závitom M6": {
		"pl": "Gwint M6",
		"hu": "M6 menettel",
		"de": "Gewinde M6",
		"en": "For screwing M6",
		"cs": "Se závitem M6",
		"it": "Con filetto M6",
		"fr": "Avec filetage M6"
	}
 },

"Materiál|Materiał|Anyag|Material|Material|Materiál|Materiale|Matériel": {
	"Drevo Buk": {
		"pl": "Drewno Bukowe",
		"hu": "Natúr bükk",
		"de": "Holz Buche",
		"en": "Wood Beech",
		"cs": "Dřevo Buk",
		"it": "Legno - faggio",
		"fr": "Bois de hetre"
	},
	"Drevo Dub": {
		"pl": "Drewno dąb",
		"hu": "Natúr tölgy",
		"de": "Holz Eiche",
		"en": "Wood Oak",
		"cs": "Dřevo dub",
		"it": "Legno - quercia",
		"fr": "Bois de chene"
	},
	"Drevo iné": {
		"pl": "Drewno inny",
		"hu": "Erdő más",
		"de": "Holz andere",
		"en": "Wood other",
		"cs": "Dřevo jiné",
		"it": "Legno - altri",
		"fr": "Bois - autre"
	},
	"Drevoplast": {
		"pl": "Drewno-plastik",
		"hu": "Fa-műanyag",
		"de": "Holz-Plastic",
		"en": "Wood-Plastic",
		"cs": "Dřevoplast",
		"it": "Legnoplastica",
		"fr": "Bois-plastique"
	},
	"Hliník": {
		"pl": "Aluminium",
		"hu": "Alumínium",
		"de": "Aluminium",
		"en": "Aluminium",
		"cs": "Hliník",
		"it": "Alluminio",
		"fr": "Aluminium"
	},
	"Chémia": {
		"pl": "Chemia",
		"hu": "Kémia",
		"de": "Bauchemie",
		"en": "Chemicals",
		"cs": "Chémie",
		"it": "Chimia",
		"fr": "Chimie"
	},
	"Keramika": {
		"pl": "Ceramika",
		"hu": "Kerámia",
		"de": "Keramik",
		"en": "Ceramics",
		"cs": "Keramika",
		"it": "Ceramica",
		"fr": "Céramique"
	},
	"Liatina": {
		"pl": "Żeliwo",
		"hu": "Öntöttvas",
		"de": "Gusseisen",
		"en": "Cast Iron",
		"cs": "Litina",
		"it": "Ghisa",
		"fr": "Fonte"
	},
	"Nerez 2205": {
		"pl": "Stal nierdzewna 2205",
		"hu": "Inox 2205",
		"de": "Edelstahl 2205",
		"en": "Stainless steel 2205",
		"cs": "Nerez 2205",
		"it": "Acciaio inossidabile 2205",
		"fr": "Inox 2205"
	},
	"Nerez AISI 304": {
		"pl": "Stal nierdzewna AISI 304",
		"hu": "Inox AISI 304",
		"de": "Edelstahl AISI 304",
		"en": "Stainless steel AISI 304",
		"cs": "Nerez AISI 304",
		"it": "Acciaio inossidabile AISI 304",
		"fr": "Inox AISI 304"
	},
	"Nerez AISI 316": {
		"pl": "Stal kwasoodporna AISI 316",
		"hu": "Inox AISI 316",
		"de": "Edelstahl AISI 316",
		"en": "Stainless steel AISI 316",
		"cs": "Nerez AISI 316",
		"it": "Acciaio inossidabile AISI 316",
		"fr": "Inox AISI 316"
	},
	"Oceľ": {
		"pl": "Stal",
		"hu": "Szén acél",
		"de": "Stahl",
		"en": "Steel",
		"cs": "Ocel",
		"it": "Acciaio",
		"fr": "Acier"
	},
	"Polykarbonát": {
		"pl": "Poliwęglan",
		"hu": "Polikarbonát",
		"de": "Polycarbonat",
		"en": "Polycarbonate",
		"cs": "Polykarbonát",
		"it": "Policarbonato",
		"fr": "Polycarbonate"
	},
	"Sklo": {
		"pl": "Szkło",
		"hu": "üveg",
		"de": "Glas",
		"en": "Glass",
		"cs": "Sklo",
		"it": "Il vetro",
		"fr": "Verre"
	},
	"ZAMAK zliatina": {
		"pl": "ZAMAK",
		"hu": "ZAMAK ötvözet",
		"de": "ZAMAK legierung",
		"en": "ZAMAK alloy",
		"cs": "ZAMAK slitina",
		"it": "ZAMAK lega",
		"fr": "ZAMAK alliage"
	},
	"Silikón": {
		"pl": "Silikon",
		"hu": "Szilikon",
		"de": "Silikon",
		"en": "Silicone",
		"cs": "Silikon",
		"it": "Silicone",
		"fr": "Silicone"
	},
	"Karbid": {
		"pl": "Węglik",
		"hu": "Karbid",
		"de": "Wolframkarbid",
		"en": "Carbide",
		"cs": "Karbid",
		"it": "Carburo",
		"fr": "Carbure"
	},
	"Mäkčené PVC": {
		"pl": "Zmiękczony PVC",
		"hu": "Lágyított PVC",
		"de": "Erweichtes PVC",
		"en": "Softened PVC",
		"cs": "Měkčené PVC",
		"it": "PVC plastificato",
		"fr": "PVC plastifié"
	},
	"Guma": {
		"pl": "Kauczuk",
		"hu": "Gumi",
		"de": "Gummi",
		"en": "Rubber",
		"cs": "Guma",
		"it": "Gomma",
		"fr": "Caoutchouc"
	},
	"plast": {
		"pl": "plastik",
		"hu": "Műanyag",
		"de": "Kunststoff",
		"en": "plastic",
		"cs": "plast",
		"it": "plastica",
		"fr": "plastique"
	},
	"Nylon": {
		"pl": "Nylon",
		"hu": "Nejlon",
		"de": "Nylon",
		"en": "Nylon",
		"cs": "Nylon",
		"it": "Nylon",
		"fr": "Nylon"
	},
	"Meď": {
		"pl": "Med Cu",
		"hu": "Med Cu",
		"de": "Cupper",
		"en": "Copper",
		"cs": "Měď",
		"it": "Rame",
		"fr": "Cuivre"
	},
	"Mosadz": {
		"pl": "Mosiądz",
		"hu": "Sárgaréz",
		"de": "Messing",
		"en": "Brass",
		"cs": "Mosaz",
		"it": "Ottone",
		"fr": "Laiton"
	},
	"Koža": {
		"pl": "skorz",
		"hu": "bőr",
		"de": "Leder",
		"en": "leather",
		"cs": "kůže",
		"it": "Cuoio",
		"fr": "Cuir"
	},
	"Drevo Dub - CINK": {
		"pl": "Drewno dąb - CINK",
		"hu": "Natúr tölgy - CINK",
		"de": "Holz Eiche - CINK",
		"en": "Wood Oak - CINK",
		"cs": "Dřevo dub - CINK",
		"it": "Legno - quercia - CINK",
		"fr": "Bois de chene - CINK"
	},
	"Drevo Buk - CINK": {
		"pl": "Drewno Bukowe - CINK",
		"hu": "Natúr bükk - CINK",
		"de": "Holz Buche - CINK",
		"en": "Wood Beech - CINK",
		"cs": "Dřevo Buk - CINK",
		"it": "Legno - faggio - CINK",
		"fr": "Bois de hetre - CINK"
	},
	"Drevo Borovica": {
		"pl": "Drewno sosnowe",
		"hu": "Fenyőfa",
		"de": "Kiefernholz",
		"en": "Wood Pine",
		"cs": "Dřevo borovice",
		"it": "Legno di pino",
		"fr": "Bois de pin"
	},
	"Drevo Teak": {
		"pl": "Drewno Teak",
		"hu": "Natúr Teak",
		"de": "Holz Teak",
		"en": "Wood Teak",
		"cs": "Dřevo Teak",
		"it": "Legno - Teak",
		"fr": "Bois de teck"
	},
	"Nerez AISI 201": {
		"pl": "Stal nierdzewna AISI 201",
		"hu": "Inox AISI 201",
		"de": "Edelstahl AISI 201",
		"en": "Stainless steel AISI 201",
		"cs": "Nerez AISI 201",
		"it": "Acciaio inossidabile AISI 201",
		"fr": "Inox AISI 201"
	},
	"Drevo Smrek": {
		"pl": "Drewno świerkowe",
		"hu": "Lucfenyőfa",
		"de": "Fichtenholz",
		"en": "Wood Spruce",
		"cs": "Dřevo smrk",
		"it": "Legno di abete rosso",
		"fr": "Bois d'épicéa"
	},
	"Polymér so skleneným vláknom": {
		"pl": "Polimer z włóknem szklanym",
		"hu": "Üvegszálas polimer",
		"de": "Glasfaserverstärkter Kunststoff",
		"en": "Glass fiber-reinforced polymer",
		"cs": "Polymer se skelným vláknem",
		"it": "Polimero con fibra di vetro",
		"fr": "Polymere avec fibre de verre"
	}
 },

"Povrchová úprava|Wykończenie powierzchni|Felület kezelés|Oberflächengüte|Surface finish|Povrchová úprava|Finitura|Finition de surface": {
	"Natural": {
		"pl": "Surowy",
		"hu": "Nyers",
		"de": "Rohzustand",
		"en": "Raw",
		"cs": "Surový stav",
		"it": "Grezzo",
		"fr": "Brut"
	},
	"Farba": {
		"pl": "Kolor",
		"hu": "Fényezett",
		"de": "Farbe",
		"en": "Color",
		"cs": "Barva",
		"it": "Colore",
		"fr": "Couleur"
	},
	"Číre": {
		"pl": "Czysty",
		"hu": "Színtelen",
		"de": "Klare",
		"en": "Clear",
		"cs": "Číre",
		"it": "Chiaro",
		"fr": "Clair"
	},
	"Eloxovaný": {
		"pl": "Anodowany",
		"hu": "eloxált",
		"de": "Eloxiert",
		"en": "Anodized",
		"cs": "Eloxovaný",
		"it": "Anodizzato",
		"fr": "Anodisé"
	},
	"Kalený": {
		"pl": "Hartowana",
		"hu": "Edzett",
		"de": "Gehärtet",
		"en": "Hardened",
		"cs": "Kalený",
		"it": "Temperato",
		"fr": "Trempé"
	},
	"Lesk": {
		"pl": "Poler",
		"hu": "Polírozott",
		"de": "Glanz",
		"en": "Polished",
		"cs": "Lesk",
		"it": "Lucido",
		"fr": "Brillant"
	},
	"Mliečne": {
		"pl": "Mleczny",
		"hu": "Tejes",
		"de": "Milchig",
		"en": "Milky",
		"cs": "Mléčné",
		"it": "Di latte",
		"fr": "Dépoli"
	},
	"Mosadz": {
		"pl": "Mosiądz",
		"hu": "Sárgaréz",
		"de": "Messing",
		"en": "Brass",
		"cs": "Mosaz",
		"it": "Ottone",
		"fr": "Laiton"
	},
	"Nikel": {
		"pl": "Nikiel",
		"hu": "Nikkel",
		"de": "Nickel",
		"en": "Nickel",
		"cs": "Nikl",
		"it": "Nichel",
		"fr": "Nickel"
	},
	"Poplastovaný": {
		"pl": "Powlekana PCV",
		"hu": "PVC bevonattal",
		"de": "PVC beschichtet",
		"en": "PVC coated",
		"cs": "Poplastovaný",
		"it": "Rivestito plastica",
		"fr": "Plastifié"
	},
	"Zdobený": {
		"pl": "Zdobiony",
		"hu": "Díszített",
		"de": "Dekoriert",
		"en": "Decorated",
		"cs": "Zdobený",
		"it": "Ornato",
		"fr": "Décoré"
	},
	"Zinok": {
		"pl": "Ocynkowany",
		"hu": "Horganyzott",
		"de": "Verzinkt",
		"en": "Galvanized",
		"cs": "Zinek",
		"it": "Zinco",
		"fr": "Zinc"
	},
	"Drevo dekor": {
		"pl": "Wystrój drewna",
		"hu": "Fa dekoráció",
		"de": "Holzdekor",
		"en": "Wood decor",
		"cs": "Dřevěný dekor",
		"it": "Decorazione in legno",
		"fr": "Décor en bois"
	},
	"Brus": {
		"pl": "Szlifowany",
		"hu": "Szálcsiszolt",
		"de": "Schliff",
		"en": "Satined",
		"cs": "Brus",
		"it": "Satinato",
		"fr": "satiné"
	},
	"Lakovaný": {
		"pl": "Lakierowany",
		"hu": "Lakkozott",
		"de": "Lackiert",
		"en": "Lacquered",
		"cs": "Lakováno",
		"it": "Laccato",
		"fr": "Laqué"
	},
	"Patina": {
		"pl": "Patyna",
		"hu": "Patina",
		"de": "Patina",
		"en": "Patina",
		"cs": "Patina",
		"it": "Patina",
		"fr": "Patine"
	},
	"Lesk-PVD": {
		"pl": "Poler-PVD",
		"hu": "Polírozott-PVD",
		"de": "Glanz-PVD",
		"en": "Polished-PVD",
		"cs": "Lesk-PVD",
		"it": "Lucido-PVD",
		"fr": "Brillant-PVD"
	},
	"Práškovaný": {
		"pl": "Lakierowanie proszkowe",
		"hu": "Porbevonat",
		"de": "Pulverbeschichtung",
		"en": "Powder coating",
		"cs": "Práškovaný",
		"it": "Verniciatura a polvere",
		"fr": "Revetement en poudre"
	},
	"Práškovaný s textúrou": {
		"pl": "Teksturowana powłoka proszkowa",
		"hu": "Texturált porbevonat",
		"de": "Strukturierte Pulverbeschichtung",
		"en": "Textured powder coating",
		"cs": "Práškovaný s textúrou",
		"it": "Verniciatura a polvere testurizzata",
		"fr": "Revetement en poudre texturé"
	},
	"Brus-PVD": {
		"pl": "Szlifowany-PVD",
		"hu": "Szálcsiszolt-PVD",
		"de": "Schliff-PVD",
		"en": "Satined-PVD",
		"cs": "Brus-PVD",
		"it": "Satinato-PVD",
		"fr": "Brossé-PVD"
	},
	"SUPER Lesk": {
		"pl": "Poler",
		"hu": "Polírozott",
		"de": "Glanz",
		"en": "Polished",
		"cs": "Lesk",
		"it": "Lucido",
		"fr": "Brillant"
	}
 },

"Spomalenie motora|Zwolnienie silnika|A motor lassulása|Motorverlangsamung|Drive slowdown|Zpomalení motoru|Allentamento del motore|Ralentissement de conduite": {
	"Spomaľuje pred koncovými polohami": {
		"pl": "Zwolnia przed końcowymi pozycjami",
		"hu": "Lelassul a véghelyzetek előtt",
		"de": "Es verlangsamt sich vor den Endpositionen",
		"en": "Drive decelerate before endpoint",
		"cs": "Spomaluje před koncovými polohami",
		"it": "decelera prima delle posizioni finali",
		"fr": "Ralentit avant les positions finales"
	},
	"Motor nemá funkciu spomalenia": {
		"pl": "Silnik nie ma spowolnienia",
		"hu": "Motor nem rendelkezik lelassulási",
		"de": "der Motor hat keine Verlangsamungsfunktion",
		"en": "Drive not decelerate",
		"cs": "Motor nemá funkci spomalení",
		"it": "Il motore non ha una funzione di decelerazione",
		"fr": "Le moteur n'a pas de fonction de décélération"
	}
},

"Stĺpik|Słupek|Korlátoszlop|Geländerpfosten|Post|Sloupek|Montante|Poste": {
	"40x40 - drevo": {
		"pl": "40x40 - drewno",
		"hu": "40x40 - fa",
		"de": "40x40 - holz",
		"en": "40x40 - wood",
		"cs": "40x40 - dřevo",
		"it": "40x40 - legno",
		"fr": "40x40 - bois"
	},
	"D50 - drevo": {
		"pl": "D50 - drewno",
		"hu": "D50 - fa",
		"de": "D50 - holz",
		"en": "D50 - wood",
		"cs": "D50 - dřevo",
		"it": "D50 - legno",
		"fr": "D50 - bois"
	}
 },

"Výplň|Wypełnienie|Korlátmező|Fülle|Filling|Výplň|Riguardo|Remplissage": {
	"Lanko": {
		"pl": "Linka",
		"hu": "Sodrony",
		"de": "Kabel",
		"en": "Cable",
		"cs": "Lanko",
		"it": "Cavo",
		"fr": "Corde"
	},
	"plech": {
		"pl": "Blacha",
		"hu": "Fémlemez",
		"de": "Blech",
		"en": "Sheet metal",
		"cs": "Plech",
		"it": "Lamiera",
		"fr": "Tôle"
	},
	"Sklo": {
		"pl": "Szkło",
		"hu": "üveg",
		"de": "Glas",
		"en": "Glass",
		"cs": "Sklo",
		"it": "Il vetro",
		"fr": "Verre"
	},
	"Lanko 1x1,5": {
		"pl": "Linka 1x1,5",
		"hu": "Sodrony 1x1,5",
		"de": "Kabel 1x1,5",
		"en": "Cable 1x1,5",
		"cs": "Lanko 1x1,5",
		"it": "Cavo 1x1,5",
		"fr": "Corde 1x1,5"
	},
	"Lanko 2x1,5": {
		"pl": "Linka 2x1,5",
		"hu": "Sodrony 2x1,5",
		"de": "Kabel 2x1,5",
		"en": "Cable 2x1,5",
		"cs": "Lanko 2x1,5",
		"it": "Cavo 2x1,5",
		"fr": "Corde 2x1,5"
	},
	"Sklo+Plech": {
		"pl": "Szkło i Blacha",
		"hu": "üveg + Fémlemez",
		"de": "Glas+Blech",
		"en": "Glass+Sheet metal",
		"cs": "Sklo+Plech",
		"it": "Il vetro+Lamiera",
		"fr": "Verre+Tôle"
	}
 },

"Vzhľad|Kolor|Árnyalat|Farbe|Effect|Vzhled|Tonalitá|Couleur": {
	"Biela": {
		"pl": "Biała",
		"hu": "Fehér",
		"de": "Weiss",
		"en": "White",
		"cs": "Bílá",
		"it": "Bianco",
		"fr": "Blanc"
	},
	"Biela RAL 9016": {
		"pl": "Biała RAL 9016",
		"hu": "Fehér RAL 9016",
		"de": "Weiss RAL 9016",
		"en": "White RAL 9016",
		"cs": "Bílá RAL 9016",
		"it": "Bianco RAL 9002",
		"fr": "Blanc RAL 9016"
	},
	"Čierna": {
		"pl": "Czarna",
		"hu": "Fekete",
		"de": "Schwarz",
		"en": "Black",
		"cs": "Černá",
		"it": "Nero",
		"fr": "Noir"
	},
	"Dub": {
		"pl": "Dąb",
		"hu": "Tölgy",
		"de": "Eiche",
		"en": "Oak",
		"cs": "Dub",
		"it": "Quercia",
		"fr": "Chene"
	},
	"Eben": {
		"pl": "Eben",
		"hu": "Eben",
		"de": "Ebenholz",
		"en": "Ebony",
		"cs": "Eben",
		"it": "Ebano",
		"fr": "Ébene"
	},
	"Grafitová": {
		"pl": "Grafit",
		"hu": "Grafit",
		"de": "Graphit",
		"en": "Graphite",
		"cs": "Grafitová",
		"it": "Grafite",
		"fr": "Graphite"
	},
	"Hnedá": {
		"pl": "Brązowy",
		"hu": "Barna",
		"de": "Braun",
		"en": "Brown",
		"cs": "Hnědá",
		"it": "Marrone",
		"fr": "Brun"
	},
	"Medená": {
		"pl": "Miedziana",
		"hu": "Réz",
		"de": "Kupfer",
		"en": "Copper",
		"cs": "Měděná",
		"it": "Rame",
		"fr": "Cuivre"
	},
	"Modrá": {
		"pl": "Niebieski",
		"hu": "Kék",
		"de": "Blau",
		"en": "Blue",
		"cs": "Modrá",
		"it": "Blu",
		"fr": "Bleu"
	},
	"Orech": {
		"pl": "Orzech",
		"hu": "Dió",
		"de": "Nutt",
		"en": "Nut",
		"cs": "Ořech",
		"it": "Noce",
		"fr": "Noyer"
	},
	"Sivá": {
		"pl": "Szary",
		"hu": "Szürke",
		"de": "Grau",
		"en": "Gray",
		"cs": "Šedá",
		"it": "Grigio",
		"fr": "Gris"
	},
	"Smrek": {
		"pl": "Świerk",
		"hu": "Lucfenyő",
		"de": "Fichte",
		"en": "Spruce",
		"cs": "Smrk",
		"it": "Abete rosso",
		"fr": "Épicéa"
	},
	"Strieborná": {
		"pl": "Srebrna",
		"hu": "Ezüst",
		"de": "Silber",
		"en": "Silver",
		"cs": "Stříbrná",
		"it": "D'argento",
		"fr": "Argent"
	},
	"Transparent": {
		"pl": "Transparentowy",
		"hu": "Átlátszó",
		"de": "Transparent",
		"en": "Transparent",
		"cs": "Transparent",
		"it": "Trasparente",
		"fr": "Transparent"
	},
	"Tyrkysová": {
		"pl": "Turkusowy",
		"hu": "Türkiz",
		"de": "Türkis",
		"en": "Turquoise",
		"cs": "Tyrkysová",
		"it": "Turchese",
		"fr": "Turquoise"
	},
	"Zelená": {
		"pl": "Zielona",
		"hu": "Zöld",
		"de": "Grün",
		"en": "Green",
		"cs": "Zelená",
		"it": "Verde",
		"fr": "Vert"
	},
	"Zlatá": {
		"pl": "Złotowa",
		"hu": "Arany",
		"de": "Gold",
		"en": "Gold",
		"cs": "Zlatá",
		"it": "D'oro",
		"fr": "Doré"
	},
	"Zlatý dub": {
		"pl": "Złotowy dąb",
		"hu": "Arany tölgy",
		"de": "Gold Eiche",
		"en": "Golden Oak",
		"cs": "Zlatý dub",
		"it": "Quercia dorata",
		"fr": "Chene doré"
	},
	"Žltá": {
		"pl": "żółta",
		"hu": "Sárga",
		"de": "Gelb",
		"en": "Yellow",
		"cs": "Žlutá",
		"it": "Giallo",
		"fr": "Jaune"
	},
	"Zelená RAL 6005": {
		"pl": "Zielona RAL 6005",
		"hu": "Zöld RAL 6005",
		"de": "Grün RAL 6005",
		"en": "Green RAL 6005",
		"cs": "Zelená RAL 6005",
		"it": "Verde RAL 6005",
		"fr": "Vert RAL 6005"
	},
	"Čierna RAL 9005": {
		"pl": "czarna RAL 9005",
		"hu": "Fekete RAL 9005",
		"de": "Schwarz RAL 9005",
		"en": "Black RAL 9005",
		"cs": "Černá RAL 9005",
		"it": "Nero RAL 9005",
		"fr": "Noir RAL 9005"
	},
	"Grafit RAL 7024": {
		"pl": "Grafit RAL 7024",
		"hu": "Grafit RAL 7024",
		"de": "Graphit RAL 7024",
		"en": "Graphite RAL 7024",
		"cs": "Grafit RAL 7024",
		"it": "Grafite RAL 7024",
		"fr": "Graphite RAL 7024"
	},
	"Sivá/Svetlosivá": {
		"pl": "Szary/Jasnoszary",
		"hu": "Szürke/Világos szürke",
		"de": "Grau/Hellgrau",
		"en": "Gray/Light gray",
		"cs": "Šedá/Světle šedá",
		"it": "Grigio/Grigio chiaro",
		"fr": "Gris/Gris clair"
	},
	"Grafit": {
		"pl": "Grafit",
		"hu": "Grafit",
		"de": "Graphit",
		"en": "Graphite",
		"cs": "Grafit",
		"it": "Grafite",
		"fr": "Graphite"
	},
	"Čierna RAL 9017": {
		"pl": "czarna RAL 9017",
		"hu": "Fekete RAL 9017",
		"de": "Schwarz RAL 9017",
		"en": "Black RAL 9017",
		"cs": "Černá RAL 9017",
		"it": "Nero RAL 9017",
		"fr": "Noir RAL 9017"
	},
	"Antracit RAL7016": {
		"pl": "Antracit RAL7016",
		"hu": "Antracit RAL7016",
		"de": "Antracit RAL7016",
		"en": "Antracit RAL7016",
		"cs": "Antracit RAL7016",
		"it": "Antracit RAL7016",
		"fr": "Antracit RAL7016"
	},
	"Hnedá/Sv.hnedá": {
		"pl": "Brązowy/Jasnobrązowy",
		"hu": "Barna/Világosbarna",
		"de": "Braun/Hellbraun",
		"en": "Brown/Light brown",
		"cs": "Hnědá/Světle hnědá",
		"it": "Marrone/Marrone chiaro",
		"fr": "Brun/Marron clair"
	},
	"Sivá RAL 9006": {
		"pl": "Szary RAL 9006",
		"hu": "Szürke RAL 9006",
		"de": "Grau RAL 9006",
		"en": "Gray RAL 9006",
		"cs": "Šedá RAL 9006",
		"it": "Grigio RAL 9006",
		"fr": "Gris RAL 9006"
	},
	"Svetlohnedá": {
		"pl": "Jasnobrązowy",
		"hu": "Világosbarna",
		"de": "Hellbraun",
		"en": "Light brown",
		"cs": "Světle hnědá",
		"it": "Marrone chiaro",
		"fr": "Marron clair"
	},
	"Červená": {
		"pl": "czerwona",
		"hu": "Piros",
		"de": "Rot",
		"en": "Red",
		"cs": "Červená",
		"it": "Rosso",
		"fr": "Rouge"
	},
	"Ultra-číre": {
		"pl": "Ultra przezroczyste",
		"hu": "Ultratiszta",
		"de": "Ultra-klar",
		"en": "Ultra-clear",
		"cs": "Ultračiré",
		"it": "Ultra-trasparente",
		"fr": "Ultra-transparent"
	},
	"Hnedá RAL 8017": {
		"pl": "Brązowy RAL 8017",
		"hu": "Barna RAL 8017",
		"de": "Braun RAL 8017",
		"en": "Brown RAL 8017",
		"cs": "Hnědá RAL 8017",
		"it": "Marrone RAL 8017",
		"fr": "Brun RAL 8017"
	},
	"Číre": {
		"pl": "Przezroczyste",
		"hu": "Átlátszó",
		"de": "Klar",
		"en": "Clear",
		"cs": "Čiré",
		"it": "Trasparente",
		"fr": "Transparent"
	},
	"Biela RAL9003": {
		"pl": "Biała RAL 9003",
		"hu": "Fehér RAL 9003",
		"de": "Weiss RAL 9003",
		"en": "White RAL 9003",
		"cs": "Bílá RAL 9003",
		"it": "Bianco RAL 9003",
		"fr": "Blanc RAL 9003"
	},
	"Béžová": {
		"pl": "Beżowy",
		"hu": "Bézs",
		"de": "Beige",
		"en": "Beige",
		"cs": "Béžová",
		"it": "Beige",
		"fr": "Beige"
	},
	"Antracit": {
		"pl": "Antracyt",
		"hu": "Antracit",
		"de": "Anthrazit",
		"en": "Anthracite",
		"cs": "Antracit",
		"it": "Antracite",
		"fr": "Anthracite"
	},
	"Natural": {
		"pl": "Naturalny",
		"hu": "Természetes",
		"de": "Natürlich",
		"en": "Natural",
		"cs": "Natural",
		"it": "Naturale",
		"fr": "Naturel"
	},
	"Čierna RAL 9004": {
		"pl": "czarna RAL 9004",
		"hu": "Fekete RAL 9004",
		"de": "Schwarz RAL 9004",
		"en": "Black RAL 9004",
		"cs": "Černá RAL 9004",
		"it": "Nero RAL 9004",
		"fr": "Noir RAL 9004"
	},
	"Mliečne": {
		"pl": "Mleczne",
		"hu": "Tejüveg",
		"de": "Milchglas",
		"en": "frosted",
		"cs": "Mléčné",
		"it": "Satinato",
		"fr": "Dépoli"
	}
 },

"Zámkový otvor|Otwór|Zár nyílás|Sperrloch|Lock hole|Zámkový otvor|Foro di blocco|Trou de serrure": {
	"Bez otvoru": {
		"pl": "Bez otworu",
		"hu": "Lyuk nélkül",
		"de": "Ohne Loch",
		"en": "Without hole",
		"cs": "Bez otvoru",
		"it": "Senza l'apertura",
		"fr": "Sans trou"
	}
 },

"Dostupnosť|Dostępność|Elérhetőség|Verfügbarkeit|Availability|Dostupnost|Disponibilità|Disponibilité": {
	"Skladom": {
		"pl": "W magazynie",
		"hu": "Raktáron",
		"de": "Auf Lager",
		"en": "In stock",
		"cs": "Skladem",
		"it": "In magazzino",
		"fr": "En stock"
	},
	"Vypredané": {
		"pl": "Wyprzedane",
		"hu": "Elfogyott",
		"de": "Ausverkauft",
		"en": "Sold out",
		"cs": "Vyprodáno",
		"it": "Esaurito",
		"fr": "Épuisé"
	}
 }, 
}

// SETTINGS END. DON'T EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

        if (Shopify.locale == 'sk') { return }

        function translateInFilter() {
            for (let filterTitle of $('.snize-product-filters-title')) {
                let formattedFilterTitle = $('.snize-filter-selected-variants-count, .snize-product-filter-count', filterTitle).length
                    ? $(filterTitle).text().replace($('.snize-filter-selected-variants-count, .snize-product-filter-count', filterTitle).text(), '').trim()
                    : $(filterTitle).text();
                
                let needTranslate = 0;
                Object.keys(filterTranslation).forEach(key => {
                    if (key.includes(formattedFilterTitle)) {
                        needTranslate = 1
                        formattedFilterTitle = key;
                    }
                });    
                // if (Object.keys(filterTranslation).includes(formattedFilterTitle)) {
                if (needTranslate) {
                    let filter = window.innerWidth > 820 ? $(filterTitle).closest('.snize-product-filters-block') : $(filterTitle).closest('.snize-product-filters-header').next();
                    let filterTranslationData = filterTranslation[formattedFilterTitle];
                    for (let filterValue of $('.snize-product-filters-list li', filter)) {
                        let filterValueText = $('.snize-product-filters-checkbox', filterValue).attr('data-se-facet-value-title');
                        if (filterValueText) {
                            let translation = filterTranslationData[filterValueText] || filterTranslationData[filterValueText.toLowerCase()];
                            if (translation) {
                                let filterCount = $('label > .needsclick .snize-filter-variant-count', filterValue).text();
                                if (!filterCount) {
                                    filterCount = '';
                                }
                                $('label > .needsclick', filterValue).text([translation[Shopify.locale]]);
                                if (!$('label > .needsclick > span', filterValue).length) {
                                    $('label > .needsclick', filterValue).append(`<span class="snize-filter-variant-count" aria-hidden="true">${filterCount}</span>`);
                                } else {
                                    $('label > .needsclick > span', filterValue).text(filterCount);
                                }
                            }
                        }
                    }
                }
            }
        }

        function translateInClearFilter() {
            for (let filterValue of $('.snize-clear-the-filter')) {
                for (let filter of Object.values(filterTranslation)) {
                    let translation = filter[$(filterValue).text()] || filter[$(filterValue).text().toLowerCase()];
                    if (translation) {
                        $(filterValue).text(translation[Shopify.locale]);
                    }
                }
            }
        }

        $(document).on('Searchanise.ResultsUpdated', function(event, container) {
            translateInFilter();
            translateInClearFilter();
        });
    })(window.Searchanise.$);
});
